// removed by extract-text-webpack-plugin
module.exports = {"slide":"slide--16O7P","content-container":"content-container--3Fc1Z","title":"title--Y2IbV","second-title":"second-title--35mZH","subtitle":"subtitle--1I7Fz","element-image":"element-image--MsZ9V","active":"active--2ArdD","desktop-bg":"desktop-bg--X9jVI","mobile-bg":"mobile-bg--3mLt5","heroButton":"heroButton--hc9Ym","desktop-title-image":"desktop-title-image--2K_bN","mobile-title-image":"mobile-title-image--3Ymxs"};


/*****************
 ** WEBPACK FOOTER
 ** ./shared-components/FadeCarouselSide/components/slide.scss
 ** module id = 1484
 ** module chunks = 17
 **/